import { get } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async list(countryId) {
    return await get(
      uriWithQueryStringParams("StateOrProvince", { countryId })
    );
  }
};
